import React, { ReactElement } from "react"
import Layout from "../../components/layout"
import useSiteMetadata from "../../hooks/siteMetadata"

function Installation(): ReactElement {
  const { nugetVersion } = useSiteMetadata()

  return (
    <Layout
      title="Installation"
      description="Installation instructions for Validatum"
    >
      <h1>Installation</h1>
      <p>
        Validatum is available for download from{" "}
        <a
          href={`https://www.nuget.org/packages/Validatum/${nugetVersion}`}
          target="_blank"
          rel="noreferrer"
        >
          Nuget
        </a>
        .
      </p>
      <Install title=".NET CLI">
        &gt; <span className="text-yellow-400">dotnet</span> add package
        Validatum <span className="text-gray-500">--version</span>{" "}
        {nugetVersion}
      </Install>
      <Install title="Package Manager">
        PM&gt; <span className="text-yellow-400">Install-Package</span>{" "}
        Validatum <span className="text-gray-500">-Version</span> {nugetVersion}
      </Install>
      <Install title="Project Reference (.csproj)">
        &lt;<span className="text-blue-300">PackageReference</span>{" "}
        <span className="text-blue-300">Include</span>="Validatum"{" "}
        <span className="text-blue-300">Version</span>="{nugetVersion}" /&gt;
      </Install>
    </Layout>
  )
}

function Install({ title, children }: any): ReactElement {
  return (
    <div className="pt-4">
      <h3>{title}</h3>
      <pre className="bg-black bg-opacity-75 rounded py-1 px-4 mt-2 overflow-x-auto z-0 relative">
        <code className="text-xs text-white font-semibold">{children}</code>
      </pre>
    </div>
  )
}

export default Installation
